import { render, staticRenderFns } from "./sort-option.vue?vue&type=template&id=6e487efc&scoped=true"
import script from "./sort-option.vue?vue&type=script&lang=ts&setup=true"
export * from "./sort-option.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./sort-option.scss?vue&type=style&index=0&id=6e487efc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@4.3.0_webpack@4.46.0__ejs@3.1.10_0212d38a6ce0de8ef75b0a1c6dc51def/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e487efc",
  null
  
)

export default component.exports